import { CardState, dateFilter, ApplicationState } from '@witkac/kartamiejska-shared';
import { mapState } from 'vuex';

export const cardMixin = {
  filters: { dateFilter },
  computed: {
    ...mapState({
      card: state => {
        const cards = [...state.card.list].sort((cardA, cardB) => cardB.id - cardA.id);
        if (!cards?.length) {
          return;
        }
        const activeCard = cards.find(card => card.state === CardState[CardState.ACTIVE]);
        if (activeCard) {
          return activeCard;
        }

        const notInactiveCard = cards.find(card => card.state !== CardState[CardState.INACTIVE]);
        return notInactiveCard || cards[0];
      },
      currentApplication: state => {
        const applications = state.application.list;
        if (!applications?.length) {
          return;
        }
        return applications.find(application => application.state === ApplicationState[ApplicationState.SUBMITTED]);
      },
      lastRejectedApplication: state => {
        const applications = state.application.list.sort(
          (a, b) => new Date(b.created).getTime() - new Date(a.created).getTime()
        );
        if (!applications?.length) {
          return;
        }
        if (applications[0].state === ApplicationState[ApplicationState.REJECTED]) {
          return applications[0];
        }
      },
      cardStateColor: state => state.settings.CARD_STATE_COLOR.value
    }),
    hasEndDate() {
      return !!this.card && this.card.endDate;
    },
    isCardActive() {
      return this.card && this.card.state === CardState[CardState.ACTIVE] && !this.isExpired && !this.isBlocked;
    },
    isExpiring() {
      if (this.hasEndDate) {
        const milisecondsInDay = 86400000;
        const cardEndDateInMs = this.expireDate.getTime();
        const daysToexpire = (cardEndDateInMs - Date.now()) / milisecondsInDay;
        return daysToexpire < 120;
      }
      return false;
    },
    expireDate() {
      if (this.hasEndDate) {
        return new Date(this.card.endDate);
      }
    },
    isInactive() {
      return this.card && this.card.state === CardState[CardState.INACTIVE];
    },
    isVirtualCardActive() {
      return !this.isExpired && this.card && this.cardStateColor.ACTIVE.includes(this.card.state);
    },
    isExpired() {
      if (this.hasEndDate) {
        return this.expireDate.getTime() < Date.now();
      }
    },
    isBlocked() {
      const card = this.card;
      if (card && card.blockEndDate) {
        return new Date(card.blockEndDate).getTime() > Date.now();
      }
    },
    expirationDate() {
      if (this.card.endDate) {
        return dateFilter(this.card.endDate);
      }
      return 'Bezterminowo';
    }
  }
};
